import { render, staticRenderFns } from "./ImpressorasMonitor.vue?vue&type=template&id=47b3796b&scoped=true"
import script from "./ImpressorasMonitor.vue?vue&type=script&lang=js"
export * from "./ImpressorasMonitor.vue?vue&type=script&lang=js"
import style0 from "./ImpressorasMonitor.vue?vue&type=style&index=0&id=47b3796b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b3796b",
  null
  
)

export default component.exports